import classNames from 'classnames';
import { formatBytes } from "../../lib/index.mjs";
import { getCoverageImageUrl } from "./getCoverageImageUrl.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function CoverageCard(_ref) {
  var _coverage$attachment_;
  var {
    className,
    coverage,
    id,
    layout,
    newTab,
    renderDate,
    withThumbnail
  } = _ref;
  var imageUrl = getCoverageImageUrl(coverage);
  var href = ((_coverage$attachment_ = coverage.attachment_oembed) === null || _coverage$attachment_ === void 0 ? void 0 : _coverage$attachment_.url) || coverage.url;
  var autoLayout = withThumbnail && imageUrl ? layout : 'horizontal';
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('prezly-slate-coverage-card-component__container', className, {
      horizontal: autoLayout === 'horizontal',
      vertical: autoLayout === 'vertical'
    }),
    children: [imageUrl && withThumbnail && /*#__PURE__*/_jsx(Thumbnail, {
      src: imageUrl,
      href: href,
      newTab: newTab
    }), /*#__PURE__*/_jsxs("div", {
      className: "prezly-slate-coverage-card-component__details",
      children: [/*#__PURE__*/_jsx(Title, {
        coverage: coverage,
        href: href,
        id: id,
        newTab: newTab
      }), /*#__PURE__*/_jsx(Description, {
        coverage: coverage
      }), /*#__PURE__*/_jsx(Meta, {
        author: coverage.author_contact,
        date: coverage.published_at,
        outlet: coverage.organisation_contact,
        renderDate: renderDate
      })]
    })]
  });
}
function Thumbnail(props) {
  var {
    href,
    newTab,
    src
  } = props;
  var Tag = href ? 'a' : 'div';
  return /*#__PURE__*/_jsx(Tag, {
    href: href || undefined,
    className: "prezly-slate-coverage-card-component__thumbnail",
    style: {
      backgroundImage: "url(\"".concat(src, "\")")
    },
    target: newTab ? '_blank' : undefined,
    children: /*#__PURE__*/_jsx("img", {
      className: "prezly-slate-coverage-card-component__thumbnail-image",
      src: src,
      alt: "Website preview"
    })
  });
}
function Title(props) {
  var _coverage$attachment_2, _coverage$attachment;
  var {
    coverage,
    href,
    id,
    newTab
  } = props;
  var title = coverage.headline || ((_coverage$attachment_2 = coverage.attachment_oembed) === null || _coverage$attachment_2 === void 0 ? void 0 : _coverage$attachment_2.title) || ((_coverage$attachment = coverage.attachment) === null || _coverage$attachment === void 0 ? void 0 : _coverage$attachment.filename) || 'Untitled';
  var Tag = href ? 'a' : 'div';
  return /*#__PURE__*/_jsx(Tag, {
    className: "prezly-slate-coverage-card-component__title",
    href: href || undefined,
    id: id,
    target: newTab ? '_blank' : undefined,
    children: title
  });
}
function Description(props) {
  var _coverage$attachment_3;
  var {
    coverage
  } = props;
  var description = (_coverage$attachment_3 = coverage.attachment_oembed) === null || _coverage$attachment_3 === void 0 ? void 0 : _coverage$attachment_3.description;
  if (description) {
    return /*#__PURE__*/_jsx("div", {
      className: "prezly-slate-coverage-card-component__description",
      children: description
    });
  }
  if (coverage.attachment) {
    return /*#__PURE__*/_jsx("div", {
      className: "prezly-slate-coverage-card-component__description",
      children: formatBytes(coverage.attachment.size)
    });
  }
  return null;
}
function Meta(props) {
  var {
    author,
    date,
    outlet,
    renderDate
  } = props;
  var hasOutlet = outlet !== null;
  var hasAuthor = author !== null;
  var hasDate = date !== null;
  if (!hasOutlet && !hasAuthor && !hasDate) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "prezly-slate-coverage-card-component__meta",
    children: [hasOutlet && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("span", {
        className: "prezly-slate-coverage-card-component__outlet",
        children: [/*#__PURE__*/_jsx("img", {
          className: "prezly-slate-coverage-card-component__outlet-icon",
          src: outlet.avatar_url,
          alt: "".concat(outlet.display_name, " avatar"),
          "aria-hidden": "true"
        }), /*#__PURE__*/_jsx("span", {
          className: "prezly-slate-coverage-card-component__outlet-name",
          children: outlet.display_name
        })]
      }), (hasAuthor || hasDate) && /*#__PURE__*/_jsx("span", {
        children: "/"
      })]
    }), hasAuthor && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        className: "prezly-slate-coverage-card-component__author",
        title: "Author",
        children: author.display_name
      }), hasDate && /*#__PURE__*/_jsx("span", {
        children: "/"
      })]
    }), hasDate && /*#__PURE__*/_jsx("span", {
      className: "prezly-slate-coverage-card-component__publication-date",
      children: renderDate(date)
    })]
  });
}